export const headers = {
  es: {
    name: "Perfil de riesgo de fondo",
    maxEquity: "Máxima exposición a renta variable",
    weight: "Peso objetivo",
    equity: "Renta variable",
    fixedIncome: "Renta fija",
  },
  en: {
    name: "Fund risk profile",
    maxEquity: "Maximum equity exposure",
    weight: "Target weight",
    equity: "Equity",
    fixedIncome: "Fixed income",
  },
};
